// Select
import { Select } from '@mantine/core'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

// SWR
import useSWR from 'swr'

// React
import { useState, useEffect } from 'react'

export default function WarrantyProductSelect({ onChange, ...props }) {
    const { requestGet } = useAxiosApi()

    // Fetch dashboard data with SWR
    const { data: { data: collections = [] } = {} } = useSWR(
        '/warranty/watch-head-ids',
        requestGet,
        {
            refreshInterval: 60000, // 60 seconds - SWR automatically pauses when tab is not visible
            revalidateOnFocus: true,
            revalidateOnReconnect: true,
        }
    )

    // Selected collection
    const [selectedCollection, setSelectedCollection] = useState(null)
    const [selectedWatchHeadId, setSelectedWatchHeadId] = useState(null)

    const collectionData = collections.map((collection) => ({
        value: collection.id.toString(),
        label: collection.name,
    }))

    // Watch heads
    const watchHeadInCollection =
        collections.find(
            (collection) => collection.id.toString() === selectedCollection
        )?.components ?? []

    const watchHeadData = watchHeadInCollection.map((watchHead) => ({
        value: watchHead.id.toString(),
        label: watchHead.name,
    }))

    // When selected collection changes, clear selected watch head
    useEffect(() => {
        if (selectedCollection) {
            setSelectedWatchHeadId(null)
            onChange(null)
        }
    }, [selectedCollection])

    // On watch head change
    const onWatchHeadChange = (value) => {
        setSelectedWatchHeadId(value)
        onChange(value)
    }

    return (
        <div className="flex flex-col gap-2">
            <Select
                label="Collection"
                placeholder="Sélectionner une collection"
                searchable
                allowDeselect={false}
                data={collectionData}
                value={selectedCollection}
                onChange={setSelectedCollection}
            />

            <Select
                label="Produit"
                placeholder="Sélectionner un produit"
                searchable
                allowDeselect={false}
                data={watchHeadData}
                value={selectedWatchHeadId}
                onChange={onWatchHeadChange}
            />
        </div>
    )
}
